import Vue from 'vue';
import Vuex from 'vuex';
import tabs from './tabs';
import login from './login';
import msg from './msg';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    tabs,
    login,
    msg,
  },
});

export default store;
